import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';

const CACHE_FILE = 'nexxup_board_cache.json';
const CACHE_TTL = 1000 * 60 * 60 * 24 * 7;

export async function getCachedBoard() {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const result = await Filesystem.readFile({
      path: CACHE_FILE,
      directory: Directory.Data,
      encoding: 'utf8',
    });
    const cached = JSON.parse(result.data);
    if (Date.now() - cached.timestamp > CACHE_TTL) return null;
    return cached.data;
  } catch { return null; }
}

export async function setCachedBoard(data) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Filesystem.writeFile({
      path: CACHE_FILE,
      directory: Directory.Data,
      data: JSON.stringify({ data, timestamp: Date.now() }),
      encoding: 'utf8',
    });
  } catch {}
}
